import { useProspect } from '@insify/funnel-components';

import { useCoBranding } from '../PropertyAndCasualty/hooks/useCoBranding';

export const useHomeLink = () => {
  const prospectId = useProspect();
  const { hasCoBranding, homepageLink: homeLinkPartner } = useCoBranding();

  if (hasCoBranding) {
    return homeLinkPartner;
  }
  return `https://www.insify.fr/${prospectId ? `?prospectId=${prospectId}` : ''}`;
};
